import { useRecoilValue } from 'recoil';
import { getS3FileUrlByKey } from '../../../../services/appService';
import { getStreamingCapture } from '../../../../services/streamingService';
import { apiParamsState } from '../../../../storage/app';
import { MinimalApiAsset } from '../../../../types/asset';
import { ChannelId } from '../../../../types/gptTypes';

function useStreaming() {
  const apiParams = useRecoilValue(apiParamsState);

  const getImagesData = async (asset: MinimalApiAsset) => {
    if (!apiParams) return;
    const { error, data } = await getStreamingCapture(asset.assetId, apiParams.clientId, asset.subClientId);
    if (!error && data) {
      const frontData = data[`channel_${ChannelId.front}`];
      const internalData = data[`channel_${ChannelId.internal}`];
      const domeData = data[`channel_${ChannelId.dome}`];
      return {
        frontData,
        internalData,
        domeData,
      };
    } else if (error) {
      return { error };
    }
  };

  const getImageUrl = async (key: string) => {
    const { url } = await getS3FileUrlByKey(key);
    return url ?? '';
  };

  const getImages = async (asset: MinimalApiAsset) => {
    const data = await getImagesData(asset);
    let frontImage = '';
    let internalImage = '';
    let domeImage = '';
    if (!data?.error) {
      const frontKey = data?.frontData?.key;
      const internalKey = data?.internalData?.key;
      const domeKey = data?.domeData?.key;
      if (frontKey) frontImage = await getImageUrl(frontKey);
      if (internalKey) internalImage = await getImageUrl(internalKey);
      if (domeKey) domeImage = await getImageUrl(domeKey);
    }

    return {
      frontImage,
      internalImage,
      domeImage,
    };
  };

  return {
    getImagesData,
    getImages,
  };
}

export default useStreaming;
